module.exports = {
  BLAZE_MONITOR_RESTRICTED_FIELDS: ['password'],
  BLAZE_MONITOR_MASK: '*****',
  BLAZE_IGNORE_ERRORS: '^Url .+ not found$',
  BLAZE_ERROR_SEPARATOR: '$'
};
